// TODO: move it into core (but how to make sure usecontext returns CrossPath's context ?)
import React from 'react';

import type CrossPathClient from '@/client/index';

export type ClientContext = CrossPathClient["Router"]["context"];

type GlobalClientContextStore = typeof globalThis & {
    __proteumClientContexts?: Record<string, React.Context<ClientContext | undefined>>;
};

const globalClientContextStore = globalThis as GlobalClientContextStore;
const clientContexts = (globalClientContextStore.__proteumClientContexts ??= {});

export const ReactClientContext =
    clientContexts['CrossPath'] ?? (clientContexts['CrossPath'] = React.createContext<ClientContext | undefined>(undefined));
export default (): ClientContext => {
    const context = React.useContext<ClientContext | undefined>(ReactClientContext);
    if (context) return context;

    throw new Error(
        'Proteum router context hook was called outside the App provider. This is a framework contract failure. ' +
            'Likely fix: move the hook back under Router.page render ownership or pass the required values explicitly. ' +
            'Re-check both SSR and client navigation after the fix.',
    );
};